import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcArrowbackFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.116 4.116a1.25 1.25 0 1 1 1.768 1.768L9.767 12l6.117 6.116a1.25 1.25 0 1 1-1.768 1.768l-7-7a1.25 1.25 0 0 1 0-1.768z"
  }));
}
var IcArrowbackFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowbackFill));

export { IcArrowbackFill as I };
